<template>
  <div class="container pa-5">
    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
    <reg-search-filter
      v-if="noSearch == null"
      v-model="filters"
    ></reg-search-filter>
    <div class="row">
      <btn-config-fields
        @open-config-modal="openConfigModal"
      ></btn-config-fields>
      <btn-export-excel @export-to-excel="exportToExcel"></btn-export-excel>
      <config-fields-modal
        v-if="configModalVisible"
        @config-fields-selected="handleFieldsSelected"
        @close-config-modal="closeConfigModal"
        @config-fields-additional="handleConfigAdditional"
        :items="items"
      />
      <v-spacer></v-spacer>
      <v-btn v-if="noSearch == null" color="primary" @click="search(true)">{{
        $t("components.regEdit.filters.searchEdit")
      }}</v-btn>
    </div>
    <v-progress-linear v-if="loading" indeterminate class="mt-5" />
    <table-grid
      :noSearch="true"
      :headers="table.headers"
      :items="items"
      :loading="table.loading"
      :actions="table.actions"
      :page="pagination.page"
      @change-page="changePage"
      :itemsPerPage="pagination.limit"
      :pageLength="lengthPaginationComp"
    />

    <dialog-d
      ref="dialogFields"
      :title="this.$t('components.regEdit.fields.fieldTitle')"
      :noActions="true"
    >
      <div v-if="itemSelected">
        <v-list
          v-if="itemSelected.regFields && itemSelected.regFields.length > 0"
        >
          <v-list-item>
            <v-list-item-title class="subtitle">
              <strong>{{
                $t("components.regEdit.fields.fieldSubtitle")
              }}</strong>
            </v-list-item-title>
            <v-list-item-title class="subtitle">
              <strong>{{
                $t("components.regEdit.fields.valueSubtitle")
              }}</strong>
            </v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>

          <div v-for="(field, i) in itemSelected.regFields" :key="i">
            <v-list-item>
              <v-list-item-title>{{ field.field }}</v-list-item-title>
              <v-list-item-title
                v-if="
                  field.value &&
                  (field.value.indexOf('http:') >= 0 ||
                    field.value.indexOf('https:') >= 0)
                "
              >
                <v-btn
                  small
                  fab
                  color="primary"
                  @click="clickAttach(field)"
                  class="ma-2"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <span
                  v-if="
                    field.value &&
                    (field.value.indexOf('mp4') >= 0 ||
                      field.value.indexOf('webm') >= 0 ||
                      field.value.indexOf('avi') >= 0)
                  "
                >
                  <v-btn
                    small
                    fab
                    color="primary"
                    @click="playDialog = true"
                    class="ma-2"
                  >
                    <v-icon>mdi-play</v-icon>
                  </v-btn>

                  <v-dialog v-model="playDialog" max-width="480">
                    <v-card>
                      <vue-player :src="field.value" autoplay></vue-player>
                    </v-card>
                  </v-dialog>
                </span>
              </v-list-item-title>
              <v-list-item-title v-else class="subtitle">{{
                field.value
              }}</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
          </div>
        </v-list>

        <div v-else>
          <v-list-item>
            <v-list-item-title>{{
              $t("components.regEdit.fields.noFields")
            }}</v-list-item-title>
          </v-list-item>
        </div>
      </div>
    </dialog-d>
  </div>
</template>

<script>
import regService from "@/services/regService.js";
import regSearchFilter from "@/components/registries/regSearchFilter";
import printerService from "@/services/printerService";
import btnConfigFields from "@/components/buttons/btnConfigFields.vue";
import btnExportExcel from "@/components/buttons/btnExportExcel.vue";
import configFieldsModal from "@/components/modals/configFieldsModal.vue";

import moment from "moment";

export default {
  props: [
    "noSearch",
    "dtStart",
    "dtEnd",
    "jobCode",
    "jobId",
    "resourceCode",
    "resourceId",
    "regTypeCode",
  ],
  components: {
    regSearchFilter,
    btnConfigFields,
    btnExportExcel,
    configFieldsModal,
  },
  data() {
    return {
      configModalVisible: false,
      items: [],
      loading: false,
      itemSelected: null,
      alert: { alerts: [], type: "error" },
      playDialog: false,
      pagination: { page: 1, limit: 30, total: 0 },
      filters: {
        jobId: null,
        dtStart: null,
        dtEnd: null,
        jobCode: null,
        resourceCode: null,
        regTypeCode: null,
        userName: null,
        regFieldsArray: true,
      },
      table: {
        loading: false,
        headers: [
          {
            text: this.$t("components.regEdit.headers.date"),
            align: "left",
            sortable: false,
            value: "date",
          },
          {
            text: this.$t("components.regEdit.headers.regType"),
            align: "left",
            sortable: false,
            value: "regTypeDescription",
          },
          {
            text: this.$t("components.regEdit.headers.job"),
            align: "left",
            sortable: false,
            value: "jobCode",
          },
          {
            text: this.$t("components.regEdit.headers.description"),
            align: "left",
            sortable: false,
            value: "jobDescription",
          },
          {
            text: this.$t("components.regEdit.headers.resource"),
            align: "left",
            sortable: false,
            value: "resourceDescription",
          },
          {
            text: this.$t("components.regEdit.headers.user"),
            align: "left",
            sortable: false,
            value: "user",
          },
          {
            text: this.$t("components.regEdit.headers.isIntegrated"),
            align: "left",
            sortable: false,
            value: "isIntegrated",
          },
          {
            text: this.$t("table.actions"),
            value: "action",
            sortable: false,
            align: "right",
          },
        ],
        actions: [
          {
            text: this.$t("components.regEdit.fields.fieldTitle"),
            icon: "mdi-pencil",
            handle: this.openFields,
            access: [this.$access.reg.show, this.$access.reg.edit],
          },
          {
            text: this.$t("print"),
            icon: "mdi-printer",
            handle: this.printer,
            access: [this.$access.reg.show],
          },
          {
            text: this.$t("components.regEdit.fields.fieldDelete"),
            icon: "mdi-delete",
            handle: this.deleteReg,
            access: [this.$access.reg.edit],
          },
        ],
      },
    };
  },
  computed: {
    lengthPaginationComp() {
      let total = this.pagination.total;
      let round = Math.ceil(total / this.pagination.limit);
      return total < 1 ? 1 : round;
    },
  },
  beforeDestroy() {
    localStorage.removeItem("selectedFields");
  },
  methods: {
    async printer(reg) {
      this.loading = true;
      let res = await printerService.sendPrintTextsByRegTypeIdAndRegId(
        reg.regId,
        reg?.regTypeId || ''
      );

      this.loading = false;
      if (!res || !res.success) this.alert.alerts = res;
    },
    itemsDateFormat(items) {
      if (!items || items.length == 0) return;

      items.forEach((item) => {
        item.date = moment(item.date).format("DD/MM/YY H:mm");
      });
    },
    clickAttach(item) {
      window.open(item.value, "_blank");
    },
    async changePage(page) {
      this.pagination.page = page;
      window.scrollTo(0, 0);
      await this.search();
    },
    async search(newRequest) {
      if (newRequest) this.pagination.page = 1;

      this.table.loading = true;

      let res = await regService.searchRegs(
        this.dtStart ? this.dtStart : this.filters.dtStart,
        this.dtEnd ? this.dtEnd : this.filters.dtEnd,
        this.jobCode ? this.jobCode : this.filters.jobCode,
        this.jobId ? this.jobId : this.filters.jobId,
        this.resourceCode ? this.resourceCode : this.filters.resourceCode,
        this.resourceId ? this.resourceId : this.filters.resourceId,
        this.regTypeCode ? this.regTypeCode : this.filters.regTypeCode,
        this.userName ? this.userName : this.filters.userName,
        this.regFieldsArray ? this.regFieldsArray : this.filters.regFieldsArray,
        this.pagination.page,
        this.pagination.limit
      );

      if (res.success) {
        this.pagination.total = res.data.total;
        this.itemsDateFormat(res.data.data);
        this.items = res.data.data;
        this.$forceUpdate();

        if (this.items[0] && this.items[0].regFields.length > 0) {
          const regFieldsArrayString = JSON.stringify(this.items[0].regFields);
          localStorage.setItem("regFieldsArray", regFieldsArrayString);
        } else if (
          this.items[0] === undefined ||
          this.items[0].regFields.length <= 0
        ) {
          localStorage.removeItem("regFieldsArray");

          const storedSelectedFields = localStorage.getItem("selectedFields");

          if (storedSelectedFields) {
            const parsedSelectedFields = JSON.parse(storedSelectedFields);

            const updatedSelectedFields = parsedSelectedFields.filter(
              (field) => !field.addFields
            );

            localStorage.setItem(
              "selectedFields",
              JSON.stringify(updatedSelectedFields)
            );

            this.handleFieldsSelected(updatedSelectedFields);
          }
        }
      } else {
        this.alert.alerts = res.data;
      }
      this.table.loading = false;
    },
    openFields(reg) {
      this.itemSelected = reg;
      this.$refs.dialogFields.open();
    },
    async deleteReg(reg) {
      let id = reg.regId;
      if (!id) return;
      let confirm = await this.$confirm();
      if (!confirm) return;
      this.table.loading = true;
      let res = await regService.delete(id);
      this.table.loading = false;
      if (!res.success) this.alert.alerts = res.data;
      await this.search();
    },
    openConfigModal() {
      this.configModalVisible = true;
    },
    closeConfigModal() {
      this.configModalVisible = false;
    },
    exportToExcel() {
      //
    },
    handleConfigAdditional(updatedRegFieldsArray) {
      this.regFieldsArray = updatedRegFieldsArray;
    },
    handleFieldsSelected(selectedFields) {
      this.table.headers = selectedFields;
    },
    clearLocalStorage() {
      localStorage.removeItem("selectedFields");
    },
  },
  mounted() {
    if (this.jobId) this.filters.jobId = this.jobId;
    if (this.dtStart) this.filters.dtStart = this.dtStart;
    if (this.dtEnd) this.filters.dtEnd = this.dtEnd;
    if (this.jobCode) this.filters.jobCode = this.jobCode;
    if (this.resourceId) this.filters.resourceId = this.resourceId;
    if (this.resourceCode) this.filters.resourceCode = this.resourceCode;
    if (this.regTypeCode) this.filters.regTypeCode = this.regTypeCode;
  },
};
</script>
